export const LOGIN = 'login';

export const LOGOUT = 'logout';

export const TITLE = 'title';

export const INVOICE = 'invoice';

export const MAP = 'map';


// WEBPACK FOOTER //
// ./src/store/type.js